import React from "react";
import Loader from 'react-loader-spinner'
import HttpService from '../../utils/Http.services';
import { checkTextTranslation, translate } from "../../utils/useful";


class TagInput extends React.Component {

    state = {
        isOpen: false,
        data: [],
        title: '',
        tempData: [],
        options: [],
        isLoading: false,
        choosen: [],
        lastNewId: 0

    }



    spliter(data) {
        let string = data ? data : ''
        // console.log(string)
        if (string && typeof string == 'string') {
            string = string.replace(/,/g, '-')
            var stringArray = string.split('-')
        }
        // console.log(stringArray)
        // var finalString = source
        // stringArray.forEach(element => {
        //     finalString = finalString[element]
        // });
        return Array.isArray(stringArray) ? stringArray : []
    }



    removeItem(index) {
        let tags = this.props.data
        tags.splice(index, 1)
        // let string = ''
        // tags.forEach((element, i) => {
        //     if (element != '')
        //         string = string + element
        //     if (i != tags.length - 1) {
        //         string = string + '-'
        //     }
        // });
        this.props.changeValue(this.props.header.key, tags, this.props.extra)

    }




    changeValue(value) {
        // console.log(this.props.data)
        let tags = this.props.data

        if (!tags) {
            tags = []
        }
        if (value.includes(',') || value.includes('-')) {
            if (tags[tags.length - 1]) {
                tags[tags.length - 1] = tags[tags.length - 1].replace('-', '').replace(',', '')
            }
            tags.push('')
        } else {
            tags[tags.length ? tags.length - 1 : 0] = value
        }
        // console.log('tags=',tags)
        // tags.splice(tags.length - 1, 1)
        // tags.push(value)
        // let string = ''
        // tags.forEach(element => {
        //     if (element != '')
        //         string = string + element + '-'
        // });
        // // console.log(string)
        // string = string + value
        // console.log(string)

        // console.log(value)
        // this.props.changeValue(this.props.header.key, string)
        this.props.changeValue(this.props.header.key, tags, this.props.extra)

    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }


    render() {
        // console.log(this.props.data)
        let tags = this.props.data
        if (!tags) {
            tags = []
        }
        // console.log(tags)
        return (
            <div className='mt-0' style={{ width: '100%', position: 'relative' }} >

                {!tags.length && (
                    <div className="h-100 flexc" style={{ position: 'absolute', top: 0 }}>
                        <label className={' mr-1 ml-1 placeholder '} style={{ whiteSpace: 'nowrap' }}>{this.props.header.information?.placeholder ? checkTextTranslation(this.props.header.information.placeholder) : 'Seperate options with commas'}</label>
                    </div>
                )}


                <div ref={ref => this.setWrapperRef(ref)} >
                    <div style={{ flexWrap: 'wrap', borderRadius: 4, display: 'flex', alignItems: 'center' }}>
                        {tags.map((prop, index) => {
                            if (index != tags.length - 1)
                                return (
                                    <div key={index} className="" style={{ overflow: 'hidden', maxWidth: 'calc(100% - 50px)', display: 'inline-flex', alignItems: 'center', paddingTop: 2, paddingBottom: 2 }}>
                                        <div className="flexcc pld-2 prd-4 py-1" key={index} style={{ position: 'relative', backgroundColor: '#eee', borderRadius: 20, marginRight: 2, marginLeft: 2, flexWrap: 'nowrap' }}>

                                            <button className="flexc mrd-2" onClick={() => this.removeItem(index)}>
                                                <div className="br-20 p-1 flexcc" style={{ backgroundColor: '#ffffffcc', width: 16, height: 16 }}>
                                                    <img className="opacity-5" src="/assets/icons/close.svg" style={{ paddingLeft: 0, color: '#78b2d0', width: 12, height: 12, }} />
                                                </div>
                                            </button>

                                            <p className="text-semibold text-smaller" style={{ whiteSpace: 'nowrap', color: '#202020', width: '100%', }}>{prop}</p>

                                        </div>

                                    </div>
                                )
                        })}
                        <div className={"position-relative mt-0 ml-1 "} style={{ maxWidth: '100%' }}>
                            <input ref={'input'} value={tags[tags.length - 1]} placeholder={(tags.length ? translate("Add ...") : null)} onChange={e => { this.changeValue(e.target.value) }} className='nofocus mediumiransansfont' style={{ overflowWrap: "break-word", backgroundColor: 'transparent', maxWidth: 'calc(100% - 50px)', minWidth: 120, width: tags[tags.length - 1]?.length * 12, border: 'none' }} />
                        </div>
                    </div>


                </div>



            </div>
        );
    }
}


export default TagInput;
